export const DEMANDE_DEVIS = {
    SET_ITEMS: 'SET_DEMANDE_DEVIS_ITEMS',
    RESET_ITEMS: 'RESET_DEMANDE_DEVIS_ITEMS',
    ADD_ITEMS: 'ADD_DEMANDE_DEVIS_ITEMS',
    SET_ITEM: 'SET_DEMANDE_DEVIS_ITEM',
    REMOVE_ITEM: 'REMOVE_DEMANDE_DEVIS_ITEM',

    SET_PAGE: 'SET_DEMANDE_DEVIS_PAGE',
    SET_NB_OF_PAGES: 'SET_DEMANDE_DEVIS_NB_OF_PAGES',
    SET_SCROLL: 'SET_DEMANDE_DEVIS_SCROLL',

    SET_SORT: 'SET_DEMANDE_DEVIS_SORT',
    RESET_FILTER: 'DEMANDE_DEVIS_RESET_FILTER',
    SET_FILTER_DEMANDE_DEVIS_ID: 'DEMANDE_DEVIS_SET_FILTER_DEMANDE_DEVIS_ID',
    SET_FILTER_DEMANDE_DEVIS_STATUS_LIST: 'SET_FILTER_DEMANDE_DEVIS_STATUS_LIST',
    SET_FILTER_ONLY_MINE: 'DEMANDE_DEVIS_SET_FILTER_ONLY_MINE',
    ADD_FILTER_SITE: 'DEMANDE_DEVIS_ADD_FILTER_SITE',
    REMOVE_FILTER_SITE: 'DEMANDE_DEVIS_REMOVE_FILTER_SITE',
    SET_FILTER_SITE: 'DEMANDE_DEVIS_SET_FILTER_SITE',
    SET_COUNT: 'DEMANDE_DEVIS_SET_COUNT',

    SET_IS_LOADING: 'SET_DEMANDE_DEVIS_IS_LOADING',
    SET_ERROR: 'SET_DEMANDE_DEVIS_ERROR',

    SET_ATTACHMENT: 'SET_ATTACHMENT',
    SET_ATTACHMENT_TYPE: 'SET_ATTACHMENT_TYPE',
    SET_ATTACHMENT_LOADING: 'SET_ATTACHMENT_LOADING',

    CLEAR_ALL: 'DEMANDE_DEVIS_CLEAR_ALL',

    SET_EXPORT_XLS_IS_LOADING: 'SET_EXPORT_XLS_IS_LOADING',
    UPDATE_OBJET:'UPDATE_OBJET'

};
